import { CookiesProvider } from "react-cookie";

import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import { Home } from "./components/home/home";
import { Login } from "./components/account/login/login";
import { TokenManager } from "./services/TokenManager";
import {Stats} from "./components/stats/userStats/Stats";
import {Leaderboard} from "./components/leaderboard/Leaderboard";
import {Players} from "./components/players/Players";
import {Account} from "./components/account/Account";
import React, {useEffect} from "react";
import {AppContextProvider} from "./components/authProvider/AuthProvider";
import {ChooseGameMode} from "./components/gameMods/chooseGameMode/chooseGameMode";
import {UserApi} from "./services/api/UserApi";
import {SoloRace} from "./components/gameMods/solo/race/soloRace";
import {UiFullLoader} from "./components/ui-components/fullLoader/UiFullLoader";
import {BackendDown} from "./components/errors/backendDown";
import {SoloClassic} from "./components/gameMods/solo/classic/soloClassic";
import {User} from "./models/User";
import {useTranslation} from "react-i18next";
import {ToastParam, ToastType, UiToast} from "./components/ui-components/toast/UiToast";
import {Fastaily} from "./components/gameMods/fastaily/fastaily";
import {MentionLegals} from "./components/main/mentionLegals";
import {Menu} from "./components/main/menu/menu";


function App() {
    const {t} = useTranslation();

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [isFetchingUser, setIsFetchingUser] = React.useState<boolean>(true);
    
    const [isConnected, setIsConnected] = React.useState<boolean>(false);
    const [user, setUser] = React.useState<User | null>(null);
    
    const [isBackendIsDown, setIsBackendIsDown] = React.useState(false);
    const [isToastOpen, setIsToastOpen] = React.useState<boolean>(false);
    const [toastParam, setToastParam] = React.useState<ToastParam>({});


    function errorToast() {
        openToastWithParams({
            type: ToastType.error,
            message: t("error.error-with-the-server")
        });
    }

    function openToastWithParams(toastParam: ToastParam) {
        setToastParam(toastParam);
        setIsToastOpen(true);
    }

    useEffect(() => {
        const token = TokenManager.getToken();

        if (!token) {
            setIsConnected(false);
            setIsFetchingUser(false);
        }

        UserApi.getConnectedUser()
            .then((user) => {
                setIsConnected(user !== null);
                if (user !== null) {
                    setUser(user);
                }
            })
            .catch(() => {
                setIsBackendIsDown(true);
                setIsConnected(false);
            })
            .finally(() => setIsFetchingUser(false));
    }, []);
    
    return (
        <>
            <UiFullLoader
                isLoading={isFetchingUser}
                minimumDuration={1.2}
                onDuration={() => setIsLoading(false)}
            />
            
            <UiToast
                open={isToastOpen}
                onClose={() => {
                    setIsToastOpen(false);
                }}
                message={toastParam.message}
                icon={toastParam.icon}
                toastType={toastParam.type}
                duration={toastParam.duration}
            />

            {!isBackendIsDown && !isLoading && <div className="h-svh overflow-x-hidden">
                <AppContextProvider
                    isConnected={isConnected}
                    setIsConnected={setIsConnected}
                    user={user}
                    setUser={setUser}
                    openToastWithParams={openToastWithParams}
                    errorToast={errorToast}
                >
                    <CookiesProvider>
                        <Router>
                            <div className="flex flex-col md:flex-row h-full overflow-hidden">
                                <Menu/>
                                <div className="w-full h-full overflow-x-hidden">
                                    <Routes>
                                        <Route path="/" element={<Home/>} />
                                        <Route path="/login" element={<Login/>}/>
                                        <Route path="/stats" element={<Stats/>}/>
                                        <Route path="/leaderboard" element={<Leaderboard/>}/>
                                        <Route path="/players" element={<Players/>}/>
                                        <Route path="/account" element={<Account/>}/>
                                        <Route path="/chooseGameMode/:idGameTheme" element={<ChooseGameMode/>}/>
                                        <Route path="/solo/race" element={<SoloRace/>}/>
                                        <Route path="/fastaily" element={<Fastaily/>}/>
                                        <Route path="/solo/classic" element={<SoloClassic/>}/>
                                        <Route path="/mention-legales" element={<MentionLegals/>}/>
                                    </Routes>
                                </div>
                            </div>
                        </Router>
                    </CookiesProvider>
                </AppContextProvider>
            </div>}

            {isBackendIsDown && <BackendDown />}
        </>
    );
}

export default App;
